import SpeciesRow from "../SpeciesRow";

export default class PlantRow extends SpeciesRow {
    constructor(provider, species, rowContainer) {
        super(provider, species, rowContainer);

        let nextElement;
        rowContainer.elt.childNodes.forEach(n => {
            if (!nextElement) {
                nextElement = n.firstChild.children[1].innerText > species.name + species.scientific_name ? n : null;
            }
        });
        if (nextElement) {
            rowContainer.elt.insertBefore(this.rowDiv.elt, nextElement);
        }

        this.rowDiv.mouseClicked(() => this.click());
    }

    mouseOver() {
        super.mouseOver();
        this.hoverSet.add(this.speciesCollection.getObjects(this.species.id))
    }

    mouseOut() {
        super.mouseOut();
        this.hoverSet.reset()
    }

    click() {
        this.hoverSet.reset();
        this.tools.setTool('select');

        let objects = this.speciesCollection.getObjects(this.species.id);
        let index = objects.indexOf(this.selection.first);

        let newIndex = index == -1
            ? 0
            : (index + 1) % objects.length;
        if (objects[newIndex] == this.selection.first) {
            this.selection.reset();
        } else {
            this.selection.select(objects[newIndex]);
        }
    }
}
